import { Box, ButtonBase, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import UserAddressOption from '../models/UserAddressOption';

interface UserAddressOptionBaseButtonProps {
    value: UserAddressOption;
    selectedValue: UserAddressOption;
    onClick: (userAddressOption: UserAddressOption) => void;
    icon: React.ReactNode;
    title: string;
}

const UserAddressOptionBaseButton: React.FC<UserAddressOptionBaseButtonProps> = observer(({ value, selectedValue, onClick, icon, title }) => {
    var isSelected = value === selectedValue;
    return (
        <Box display={"flex"} flexDirection={"column"} alignItems={"center"}>
            <ButtonBase
                onClick={() => onClick(value)}
                sx={(theme) => ({
                    boxShadow: isSelected ? theme.shadows[10] : theme.shadows[9],
                    backgroundColor: isSelected ? theme.palette.secondary.light : "Background",
                    p: 2,
                    justifyContent: "flex-start"
                })}>
                {icon}
            </ButtonBase>
            <Typography mt={0.5} variant='caption'>{title}</Typography>
        </Box>
    )
})

export default UserAddressOptionBaseButton;